var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeviceInternalMirrorLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    enableBackground: "new 0 0 60 60",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "black",
    stroke: "black",
    strokeWidth: 0.36,
    d: "M15,36.6h31.4c1.7,0,3.1-1.4,3.1-3.1v-6c0-1.7-1.4-3.1-3.1-3.1H15 v2h31.4c0.6,0,1.1,0.5,1.1,1.1v6c0,0.6-0.5,1.1-1.1,1.1H15V36.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    stroke: "black",
    strokeWidth: 0.36,
    d: "M15,24.5c-1.7,0-3.1,1.4-3.1,3.1v6c0,1.7,1.4,3.1,3.1,3.1v-2 c-0.6,0-1.1-0.5-1.1-1.1v-6c0-0.6,0.5-1.1,1.1-1.1V24.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    stroke: "black",
    strokeMiterlimit: 10,
    d: "M34,18.5c0.6,0,1.1,0.5,1.1,1.1s-0.5,4.3-1.1,4.3l0,0h-6.6 c-0.6,0-1.1-3.7-1.1-4.3c0-0.6,0.5-1.1,1.1-1.1l0,0C27.4,18.5,34,18.5,34,18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M46.5,28.1c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7S46.5,27.7,46.5,28.1z"
  }))), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 0.36,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M30.7,27.5 "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceInternalMirrorLight);
export default __webpack_public_path__ + "static/media/device-internal-mirror-light.098351f3da2175accbd497c0ac790e29.svg";
export { ForwardRef as ReactComponent };